import { render } from "./ServerSelection.vue?vue&type=template&id=f21c40c8&scoped=true"
import script from "./ServerSelection.vue?vue&type=script&lang=js"
export * from "./ServerSelection.vue?vue&type=script&lang=js"

import "./ServerSelection.vue?vue&type=style&index=0&id=f21c40c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f21c40c8"]])

export default __exports__